import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
} from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { meQueryOptions } from '../../api/me';

export const Route = createFileRoute('/_auth/admin')({
  loader: async ({ context }) => {
    const me = await context.queryClient.query({
      ...meQueryOptions(),
      staleTime: 'static',
    });
    if (me.role !== 'admin') {
      throw redirect({ to: '/' });
    }
    return { me };
  },
  component: AdminLayout,
});

function AdminLayout() {
  const { me } = Route.useLoaderData();
  const { t } = useTranslation();

  return (
    <div>
      <div className="-mx-8 -mt-12 mb-10 border-b-2 border-ink bg-bg-soft px-8">
        <div className="mx-auto flex max-w-[1280px] flex-wrap items-end justify-between gap-6 pt-8 pb-0">
          <div className="flex items-center gap-5">
            <Link to="/" className="btn-link">
              ← {t('admin.backToApp', 'Tableau de bord')}
            </Link>
            <span className="my-1 w-px self-stretch bg-rule" />
            <div>
              <p className="label dash">
                {t('admin.consoleLabel', 'CONSOLE INTERNE')}
              </p>
              <h1 className="display mt-1 text-3xl">
                {t('admin.title', 'ADMINISTRATION')}
              </h1>
            </div>
          </div>
          <span className="epi-tag ink">
            ROLE · {me.role?.toUpperCase() ?? 'GUEST'}
          </span>
        </div>

        <nav className="mx-auto mt-6 flex max-w-[1280px] flex-wrap items-center gap-x-8 gap-y-1">
          <AdminTab
            to="/admin/templates"
            label={t('admin.tabs.templates', 'Templates & Faces')}
          />
          <AdminTab
            to="/admin/users"
            label={t('admin.tabs.users', 'Utilisateurs')}
          />
          <AdminTab to="/admin/logs" label={t('admin.tabs.logs', 'Logs')} />
          <AdminTab
            to="/admin/dashboard"
            label={t('admin.tabs.dashboard', 'Dashboard')}
          />
        </nav>
      </div>

      <Outlet />
    </div>
  );
}

function AdminTab({ to, label }: { to: string; label: string }) {
  return (
    <Link to={to} className="admin-tab" activeProps={{ className: 'active' }}>
      {label}
    </Link>
  );
}
